<app-modal
  [title]="'Input card code' | trans:'cards/card-code-input-modal/action/' + cardActionType + '/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      @if (cardActionType === 'exchange-card-old') {
        <p class="m-b-16">
          {{ 'Enter old card number' | trans:'cards/card-code-input-modal/action/exchange-card-old/instruction.Text' }}
        </p>
      }
      @if (cardActionType === 'exchange-card-new') {
        <p class="m-b-16">
          {{ 'Enter new card number' | trans:'cards/card-code-input-modal/action/exchange-card-new/instruction.Text' }}
        </p>
      }
      <app-form-control
        label="{{ 'Code'| trans:'cards/card-code-input-modal/action/' + cardActionType + '/code.Label' }}"
      >
        <input
          #codeInput
          type="text"
          [(ngModel)]="code"
          (keydown.enter)="onSubmit()"
          placeholder="{{ 'Enter card code'| trans:'cards/card-code-input-modal/action/' + cardActionType + '/code.Placeholder' }}"
        >
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'cards/card-code-input-modal/action/' + cardActionType + '/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!code || isLoading()"
        (click)="onSubmit()"
      >
        {{ 'Confirm'| trans:'cards/card-code-input-modal/action/' + cardActionType + '/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-modal
  [title]="'Produkte auf der Karte' | trans:'cards/card-products-selection-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
  #cardProductsSelectionModal
>
  <ng-template>
    <div class="d-flex flex-direction-column gap-4">
      @for (product of cardProducts; track product.id) {
        <div
          #productEL
          class="c-bg-blue-300 base-border-radius full-height full-width p-4 d-flex flex-direction-column cursor-pointer"
          (click)="addProductToCart(product, productEL)"
        >
          <p class="full-width flex-grow-1 overflow-hidden text-overflow-ellipsis c-t-blue-900">
            {{ product.name }}
          </p>
          <div class="d-flex justify-content-flex-end m-t-auto p-t-4">
            <div class="width-fit-content p-4 base-border-radius c-bg-blue-200 p3">
              {{ product.bottomText }}
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="cardProductsSelectionModal.close()"
      >
        {{ 'Cancel'| trans:'cards/card-products-selection-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
